module.exports = __webpack_public_path__ + "img/msg-gifs.357bac9a.png";